import get from 'lodash/get';
import clearNumber from './clearNumber';
import beautifyNumber from './beautifyNumber';
import { VAT } from '../constants';
import getDecimal from '../utils/getDecimal';
import { couponsTypes, discountCouponsTypes } from '../containers/DiscountCouponContainer/couponsConfig';
import { PROMOTIONS } from '../packagesData';

const calcDiscountedPrice = (price, discount) => Math.floor(price * (1 - (discount / 100)));
export const calculatePriceWithVAT = (beforeVat, vat = VAT) => (beforeVat + ((vat * beforeVat) / 100));

export const calculatePriceWithDiscount = (pack, period) => {
  const price = get(pack, `period[${period}].price`);
  const discount = get(pack, `period[${period}].discount`);

  return discount ? calcDiscountedPrice(price, discount) : price;
};

export const getPackagePriceForOneMonth = (current = {}, packages = []) => {
  const selectedPackage = packages.find(({ id }) => (id === current.checked));
  const { period, alternativePeriod } = current;
  const currentPeriod = get(selectedPackage, `period.${period}`) ? period : alternativePeriod;

  return calculatePriceWithDiscount(selectedPackage, currentPeriod);
};

export const getDiscountValue = (couponValue, currentPackage) => {
  if (typeof couponValue === 'number') { return couponValue; }

  const key = `package_id_${currentPackage.checked}_${currentPackage.period}`;

  return couponValue[key] || 0;
};

export const getCouponBonus = (amount, coupon, currentPackage, packages) => {
  let bonusAmount;
  const couponDescription = get(discountCouponsTypes, `[${coupon}]`, {});
  const { type: couponType, value: couponValue } = couponDescription;

  if (couponType === couponsTypes.DISCOUNT) {
    const discount = getDiscountValue(couponValue, currentPackage);
    bonusAmount = (amount * discount) / 100;
  }

  if (couponType === couponsTypes.FREE) {
    bonusAmount = getPackagePriceForOneMonth(currentPackage, packages) * couponValue;
  }

  return bonusAmount;
};

export const calculatePaymentAmountForRequest = ({ checked, period, alternativePeriod }, packages) => {
  const selectedPackage = packages.filter(pack => pack.id === checked)[0] || {};
  const currentPeriod = get(selectedPackage, `period.${period}`) ? period : alternativePeriod;

  const priceWithDiscount = calculatePriceWithDiscount(selectedPackage, currentPeriod);
  const isShouldCalcTotal = !!selectedPackage.properties;

  return (isShouldCalcTotal) ? priceWithDiscount * currentPeriod : priceWithDiscount;
};

export const calculatePaymentAmountWithVatForRequest = ({ checked, period, alternativePeriod }, packages, coupon) => {
  const beforeVat = calculatePaymentAmountForRequest({ checked, period, alternativePeriod }, packages);
  const couponBonus = (!!coupon)
    ? getCouponBonus(beforeVat, coupon, { checked, period, alternativePeriod }, packages)
    : 0;
  const beforeVatWithBonus = beforeVat - couponBonus;

  const withVAT = calculatePriceWithVAT(beforeVatWithBonus, VAT);
  const priceGrand = getDecimal(withVAT).toString().substring(2).length > 2 ?
  ((parseInt((withVAT * 100), 10)) / 100) : withVAT;

  const tax = withVAT - beforeVat;
  return { priceGrand, tax, couponBonus };
};

export const calculatePaymentAmount = (current, packages) => {
  const amount = calculatePaymentAmountForRequest(current, packages);
  return beautifyNumber(clearNumber(amount));
};

export const calculatePriceForOneProperty = (pack, period) =>
  Math.round(calculatePriceWithDiscount(pack, period) / pack.properties);
